export default __webpack_public_path__ + "images/79c8f9076fcac5c9a63289ef3b60a491-reset.svg";